Webhook:
  description: Webhook
  type: object
  properties:
    dir_seq:
      type: integer
      description: フォルダのseqです。
    user_seq:
      type: integer
      description: 作成者のseqです。
    # auth_token:
    #   type: string
    #   description: |
    #     [Webhook Payload](#section/Webhook-Payload) 요청의 `Authorization` 헤더에 사용될 인증 토큰입니다.
    url:
      type: string
      description: Webhookイベント通知先のURLです。
    triggers:
      $ref: '#/TriggerList'
    created_at:
      type: integer
      description: 作成日時、unix timestamp
    modified_at:
      type: integer
      description: 修正日時、unix timestamp

TriggerList:
  description: |
    Webhook通知対象のイベントトリガーリストです。

    イベントトリガーリストの情報は[こちら](#Webhook-Event-Triggers)でご確認いただけます。
  #  트리거에 목록 정보는 **[여기](#section/Webhook-Event-Triggers)**에서 확인 가능합니다.
  type: array
  items:
    $ref: '#/Trigger'

Trigger:
  description: イベントトリガー
  type: string
  enum:
    - file-uploaded
    - file-downloaded
    - file-deleted
    - file-restored
    - file-copied
    - file-renamed
    - file-moved
    - folder-created
    - folder-renamed
    - folder-restored
    - folder-deleted
    - folder-copied
    - folder-moved

WebhookPayload:
  description: |
    ウェブフックイベントが発生した場合、ペイロード
  type: object
  properties:
    notification_id:
      description: お知らせの固有ID
      type: string
    type:
      type: string
      example: "outgoing-webhook"
    trigger:
      $ref: '#/Trigger'
    company_code:
      description: 会社固有コード
      type: string
    user_id:
      description: ユーザーID
      type: string
    username:
      description: ユーザー名
      type: string
    source:
      description: |
        イベント対象情報
      type: object
      properties:
        type:
          type: string
          enum:
            - file
            - folder
        file_seq:
          description: ファイルの固有識別子
          type: integer
        dir_seq:
          description: フォルダーの固有識別子
          type: integer
        node:
          description: フォルダーのノード
          type: string
          example: 1{24wk
        name:
          description: ファイルまたはフォルダの名前
          type: string
        size:
          description: ファイルサイズ (Byte)
          type: integer
        dir_path:
          description: フォルダー経路
          type: string
          example: "/共有/webhookTest"
    from:
      description: |
        ファイルまたはフォルダが移動、コピーされる前に存在していたフォルダの情報
      type: object
      properties:
        dir_seq:
          description: フォルダの固有識別子
          type: string
        node:
          description: フォルダーのノード
          type: string
          example: 1{2hpg
        dir_path:
          description: フォルダー経路
          type: string
          example: "/共有/uploadTest"
    webhook:
      $ref: '#/Webhook'
    timestamp:
      description: イベント発生時間 (UNIX-TIMESTAMP)
      type: integer